module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAATklEQVQYlWN8/fn3fwYSABMpikGA5T+S+WJ8rBgKXn36jWrDX6AGGH7+EVUSxEeWB2EmkA3I+NkHiCYQjS4HwoxPPpDmaZaff0hRzsAAAM4BOcTuJZCWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xstb1-7.png
// module id = 804
// module chunks = 0